import { connect } from "react-redux";
import { KPTable } from "../components/KPTable";
import { changeDirtyFilter, changePage, changePageSize, register, changeGlobalCheckAll } from "../actions/actions";
import { doCallLoaderFunc } from "../actions/thunks";
function mapStateToProps({ kptable }, { id }) {
    return {
        table: kptable[id],
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onCallLoaderFunc: (id, loaderFunc, silent) => dispatch(doCallLoaderFunc(id, loaderFunc, silent)),
        onRegister: (id, state) => dispatch(register(id, state)),
        onPageChange: async (id, newPage, loaderFunc) => {
            dispatch(changePage(id, newPage));
            await dispatch(doCallLoaderFunc(id, loaderFunc, false));
        },
        onChangePageSize: async (id, newPageSize, totalCount, skip, loaderFunc) => {
            dispatch(changePageSize(id, newPageSize));
            const lastPage = Math.max(Math.ceil(totalCount / newPageSize) - 1, 0);
            if (lastPage < skip) {
                dispatch(changePage(id, lastPage));
            }
            await dispatch(doCallLoaderFunc(id, loaderFunc));
        },
        onSetPage: (id, newPage) => dispatch(changePage(id, newPage)),
        onChangeDirtyFilter: (id, name, value) => dispatch(changeDirtyFilter(id, name, value)),
        onChangeGlobalCheckAll: (id, all) => dispatch(changeGlobalCheckAll(id, all)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(KPTable);
